import React, {useState, useEffect} from 'react';
import { Button, InputLabel, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import { useAuth } from '../../Context/AuthContext';
import Alerta from '../../../components/Alerta';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { db } from '../../../firebase/firebaseConfig';
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';
import { getUnixTime } from 'date-fns';
//import editarCertificado from '../../../firebase/Certificado/editarCertificado';

const FormularioCertificados = ({ certificadosSeleccionado }) => {
    const isItem = true;
    const [titulo, setTitulo] = useState('');
    const [autor, setAutor] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [urlarticulo, setUrlarticulo] = useState('');
	const [fecha, setFecha] = useState(new Date());
    const [categoria, setCategoria] = useState('');
    const {usuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [imagen, setImagen] = useState(null); 
    const [modoEdicion, setModoEdicion] = useState(false); // Variable de estado para el modo de edición

    console.log('Estoy en FormularioCertificados ' + certificadosSeleccionado);

    useEffect(() => {
        const obtenerCertificado = async () => {
          if (!certificadosSeleccionado) return; // Asegúrate de que haya un Certificado seleccionado
          try {
            const certificadoDoc = await getDoc(doc(db, 'certificadocalocho', certificadosSeleccionado));
            if (certificadoDoc.exists()) {
                setModoEdicion(true);
                const certificadoData = certificadoDoc.data();
                setTitulo(certificadoData.titulo || '');
                setAutor(certificadoData.autor || '');
                setDescripcion(certificadoData.descripcion || '');
                setUrlarticulo(certificadoData.urlarticulo || '');
                setFecha(certificadoData.fecha ? new Date(certificadoData.fecha) : new Date());
                setCategoria(certificadoData.categoria || '');
                setImagen(certificadoData.imagen || null);
            } else {
              console.log('No se encontró el documento');
              setModoEdicion(false);
            }
          } catch (error) {
            console.error('Error al obtener el documento:', error);
          }
        };
      
        obtenerCertificado();
    }, [certificadosSeleccionado]); // Asegúrate de que useEffect se ejecute cuando cambie certificadosSeleccionado
      
    const handleChange = (e) => {
        if(e.target.name === 'titulo'){
            setTitulo(e.target.value);
        } else if(e.target.name === 'autor'){
            setAutor(e.target.value);
        } else if(e.target.name === 'descripcion'){
            setDescripcion(e.target.value);
        } else if(e.target.name === 'dirweb'){
            setUrlarticulo(e.target.value);
        } else if(e.target.name === 'categoria'){
            setCategoria(e.target.value);
        } else if (e.target.name === 'fecha'){
            setFecha(new Date(e.target.value));
        } else if (e.target.name === 'imagen') {
            const file = e.target.files[0];
            setImagen(file);
        }
    }
    
    const handleUpload = async (imagen) => {
        if (imagen) {
    
            try {
                const storageRef = getStorage(); // Obtener la instancia de almacenamiento
                const fileRef = ref(storageRef, `certificadocalocho/${imagen.name}`); // Obtener una referencia al archivo

                // Subir la imagen
                const snapshot = await uploadBytesResumable(fileRef, imagen);
                console.log('Imagen subida correctamente:', snapshot);
    
                // Obtener la URL de descarga
                const downloadURL = await getDownloadURL(snapshot.ref);
                console.log('URL de la imagen:', downloadURL);

                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Imagen subida correctamente' });
                
                // Devuelve la URL de la imagen
                return downloadURL;

            } catch (error) {
                console.error('Error al subir la imagen:', error);
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al subir la imagen' });
                return null;
            }
        } else {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return null;
        }
    }
    

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!imagen) {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return;
        }
    
        try {
            const imageUrl = await handleUpload(imagen);

            if(modoEdicion && certificadosSeleccionado.id){
                // Crear el objeto de datos actualizado
                //const datosActualizados = {
                //    titulo: titulo,
                //    autor: autor,
                //    descripcion: descripcion,
                //    urlarticulo: urlarticulo,
                //    fecha: getUnixTime(fecha),
                //    categoria: categoria,
                //    imagen: imageUrl
                //};
    
                // Llamar a la función editarCertificado con los datos actualizados
                //await editarCertificado(certificadosSeleccionado.id, datosActualizados);

                // Cambiar el estado de modoEdicion a falso para volver al modo de creación
                setModoEdicion(false);
                
                // Limpiar el formulario después de agregar el Certificado
                setTitulo('');
                setAutor('');
                setDescripcion('');
                setUrlarticulo('');
                setFecha(new Date());
                setCategoria('');
                setImagen(null);
                certificadosSeleccionado('');
                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Certificado actualizado correctamente' });
            
            } else {
                

                if(imageUrl){
                    // Agregar el Certificado a Firestore con la URL de la imagen
                    await addDoc(collection(db, 'certificadocalocho'), {
                        titulo: titulo,
                        autor: autor,
                        descripcion: descripcion,
                        urlarticulo: urlarticulo,
                        fecha: getUnixTime(fecha),
                        categoria: categoria,
                        imagen: imageUrl, // URL de la imagen
                        uidUsuario: usuario.uid
                    });
    
                    // Limpiar el formulario después de agregar el Certificado
                    setTitulo('');
                    setAutor('');
                    setDescripcion('');
                    setUrlarticulo('');
                    setFecha(new Date());
                    setCategoria('');
                    setImagen(null);
    
                    // Mostrar mensaje de éxito
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'exito', mensaje: 'Certificado agregado correctamente' });
                } else {
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'error', mensaje: 'Error al agregar el Certificado' });
                }
            }

            // Limpiar el formulario después de agregar el Certificado
            setTitulo('');
            setAutor('');
            setDescripcion('');
            setUrlarticulo('');
            setFecha('');
            setCategoria('');
            setImagen(null);

        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al agregar el Certificado' });
        }
    }

    return (
        <Paper onSubmit={handleSubmit} component="form" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: '500px',
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            gap: 2,
            // Añadimos media queries aquí
            '@media (max-width: 1024px)': { // Tablets
                width: '85%',  // Ocupar un poco más de ancho
                padding: 1,  // Reducir el padding
            },
            '@media (max-width: 600px)': {  // Móviles
                width: '100%',  // Ocupar todo el ancho
                padding: 1,  // Padding más pequeño
            },
        }}>
            <Typography variant='h5' sx={{
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // En móviles, reducir el tamaño del texto
                    fontSize: '1.25rem',  // Ajustamos el tamaño de la fuente
                }
            }}>Nuestro certificado</Typography>

            <TextField                  
                required
                size="small"
                id="titulo"
                fullWidth
                label="Título del certificado"
                name="titulo"
                value={titulo}
                onChange={handleChange}
                />
            <TextField                  
                required
                size="small"
                fullWidth
                id="autor"
                label="Autor"
                name="autor"
                value={autor}
                onChange={handleChange}/>


            <TextField                  
                required
                size="small"
                fullWidth
                id="descripcion"
                multiline
                label="Descripción del certificado"
                name="descripcion"
                value={descripcion}
                onChange={handleChange}/>

            <InputLabel id="categoria-label">Categoría del certificado</InputLabel>
            <Select
                required
                size="small"
                fullWidth
                labelId="categoria-label"
                id="categoria"
                name='categoria'
                value={categoria}
                onChange={handleChange}
            >
                <MenuItem value="">Seleccionar categoría</MenuItem>
                <MenuItem value="tecnología">Tecnología</MenuItem>
                <MenuItem value="viajes">Viajes</MenuItem>
                <MenuItem value="comida">Comida</MenuItem>
                {/* Agrega más categorías según tus necesidades */}
            </Select>

            <TextField                  
                required
                size="small"
                fullWidth
                id="dirweb"
                label="Link del articulo"
                name="dirweb"
                value={urlarticulo}
                onChange={handleChange}/>

            <InputLabel id="fecha-label">Seleccione la fecha de la publicación</InputLabel>
            <TextField                  
                fullWidth
                size="small"
                id="fecha"
                name="fecha"
                type='date'
                fecha={fecha} 
                onChange={handleChange}
                InputLabelProps={{
                    shrink: true,
                }}
            />

            <InputLabel id="img-label">Seleccione una imagen</InputLabel>
            <TextField                  
                fullWidth
                size="small"
                id="imagen"
                name="imagen"
                type='file'
                onChange={handleChange}
                inputProps={{ accept: 'image/*' }}/>

            <Button item={isItem.toString()} xs={12} sm={6}           
                type="submit"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mt: 3, mb: 2 }}
            >{certificadosSeleccionado ? 'Editar certificado' : 'Agregar certificado'}</Button>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </Paper>
    );
}

export default FormularioCertificados;